module.exports = __webpack_public_path__ + "static/media/body.76bcba12.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/measurements/body.png
// module id = 188
// module chunks = 0